import { createFileRoute } from '@tanstack/react-router'
import { VerifyEmailPage } from '@/features/auth'

interface VerifyEmailSearch {
  /** The address the email OTP was sent to (for display + resend). */
  email?: string
}

/** `/login/verify-email` — Step 1 of 4: email OTP. */
export const Route = createFileRoute('/login/verify-email')({
  validateSearch: (search: Record<string, unknown>): VerifyEmailSearch => ({
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
  component: VerifyEmailRoute,
})

function VerifyEmailRoute() {
  const { email } = Route.useSearch()
  return <VerifyEmailPage email={email} />
}
